import Vue from 'vue'
import genericAudioModalComponent from './template'
Vue.component('bus-stops-generic-audio-modal', genericAudioModalComponent)
